// @flow

import _ from "lodash";

import type { Results } from "../data/results";

export type LimitKind = "seconds" | "questions";

// End the sequence of questions based on either
// - the total time spent in questions (in seconds), OR
// - the number of questions done
export type Limit = {
  kind: LimitKind,
  value: number
};

export type WorkProgress = {
  kind: LimitKind,
  remaining: number,
  required: number
};

export function workProgress(
  limit: Limit,
  results: Array<Results>
): WorkProgress {
  let accomplished;
  if (limit.kind === "seconds") {
    accomplished = _(results)
      .map(results => results.toArray())
      .flatten()
      .filter({ kind: "response" })
      .sumBy("secondsElapsed");
  } else if (limit.kind === "questions") {
    accomplished = _(results).size();
  } else {
    throw new Error(
      `Trying to get work progress with unknown ${limit.kind} limit`
    );
  }

  return {
    kind: limit.kind,
    remaining: limit.value - accomplished,
    required: limit.value
  };
}

export function progressMessage(progress: WorkProgress) {
  if (progress.kind === "seconds") {
    const minutesRemaining = _.round(progress.remaining / 60);
    const minutesRequired = _.round(progress.required / 60);

    return `Question time remaining: ~${minutesRemaining} of ${minutesRequired} minutes`;
  } else if (progress.kind === "questions") {
    const accomplished = progress.required - progress.remaining;

    return `Done: ${accomplished} / ${progress.required} `;
  } else {
    throw new Error(
      `Unable to serve progress message with unknown ${progress.kind} limit`
    );
  }
}



// WEBPACK FOOTER //
// ./src/utils/progress.js